module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-t-mobile-bottom-01.1.23a94af9.jpg";